module.exports = __webpack_public_path__ + "img/cir-cen1.8b4cff3a.png";